module.exports = __webpack_public_path__ + "img/language-en.aee70724.jpg";